import React, { useState, useContext, useEffect } from "react";
import {
  Form,
  Button,
  Alert,
  Container,
  Row,
  Col,
  Spinner,
  Card,
} from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import api, { publicApi } from "../api";
import GoogleLoginButton from "./GoogleLoginButton";

const Login = () => {
  const [error, setError] = useState("");
  const [googleEnabled, setGoogleEnabled] = useState(true);
  const location = useLocation();

  useEffect(() => {
    // Clear any previous tokens on login page load
    if (location.pathname === "/login") {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("tokenType");

      // Clear authorization header
      if (api.defaults.headers.common["Authorization"]) {
        delete api.defaults.headers.common["Authorization"];
      }

      // Show error if redirected due to token expiration
      if (location.search.includes("expired=true")) {
        setError("Your session has expired. Please log in again.");
      }
    }

    const fetchSystemSettings = async () => {
      try {
        const response = await publicApi.get("/api/public-settings/");
        if (response && response.data) {
          setGoogleEnabled(response.data.enable_google_login === "true");
        }
      } catch (err) {
        console.error("Failed to fetch system settings:", err);
        // Default to enabled if we can't fetch settings
        setGoogleEnabled(true);
      }
    };

    fetchSystemSettings();
  }, [location.pathname, location.search]);

  return (
    <Container>
      <Row className="justify-content-center">
        <Col md={6}>
          <Card className="mt-5 shadow-sm">
            <Card.Body className="p-4">
              <div className="text-center mb-4">
                <h2 className="mb-3">Welcome to Lion City Exams</h2>
                <p className="text-muted">Sign in to access your account</p>
              </div>

              {error && (
                <Alert
                  variant="danger"
                  onClose={() => setError("")}
                  dismissible
                >
                  {error}
                </Alert>
              )}

              {googleEnabled && (
                <div className="mt-4">
                  <GoogleLoginButton />
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
